import React from 'react'
import { Card, CardHeader, Divider, Grid, TextField } from '@mui/material'

import { PropertyList } from '../../../../../components/PropertyList'
import CircularLoading from '../../../../../components/CircularProgress'
import { IMerchant } from '../../../../../types/merchant'

interface FilterGroupProps {
  isLoading: boolean
  merchant?: IMerchant
  updateMerchant?: (data: Partial<IMerchant>) => void
}

const MerchantDetailCard = ({ isLoading, merchant, updateMerchant }: FilterGroupProps) => {
  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <Card
        sx={{
          padding: 2,
        }}>
        <CardHeader title="ใบเสร็จรับเงิน/ใบกำกับภาษี" />
        <Divider />
        <PropertyList>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <TextField
                required
                id="name"
                fullWidth
                label="ชื่อบริษัท"
                name="name"
                defaultValue={merchant?.name}
                onChange={(e) => updateMerchant?.({ name: e.target.value })}
                helperText="ชื่อบริษัทที่จะแสดงในใบเสร็จรับเงิน/ใบกำกับภาษี"
                error={!merchant?.name}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <TextField
                required
                id="address"
                fullWidth
                label="ที่อยู่บริษัท"
                name="address"
                defaultValue={merchant?.address}
                onChange={(e) => updateMerchant?.({ address: e.target.value })}
                helperText="ที่อยู่บริษัทที่จะแสดงในใบเสร็จรับเงิน/ใบกำกับภาษี"
                error={!merchant?.address}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                required
                id="phoneNumber"
                fullWidth
                label="เบอร์โทรศัพท์"
                name="phoneNumber"
                defaultValue={merchant?.phoneNumber}
                onChange={(e) => updateMerchant?.({ phoneNumber: e.target.value })}
                helperText="เบอร์โทรศัพท์ที่จะแสดงในใบเสร็จรับเงิน/ใบกำกับภาษี"
                error={!merchant?.phoneNumber}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                required
                id="taxId"
                fullWidth
                label="เลขประจำตัวผู้เสียภาษี"
                name="taxId"
                defaultValue={merchant?.taxIdentificationNumber}
                onChange={(e) => updateMerchant?.({ taxIdentificationNumber: e.target.value })}
                helperText="เลขประจำตัวผู้เสียภาษีที่จะแสดงในใบเสร็จรับเงิน/ใบกำกับภาษี"
                error={!merchant?.taxIdentificationNumber}
              />
            </Grid>
          </Grid>
        </PropertyList>
      </Card>
    </>
  )
}

export default MerchantDetailCard
